import { useCurrentUser } from "@/provider/currentUser";
import { CalendarBlock } from "@moim/blockit";
import React from "react";
import DateItem from "./elements/DateItem";
import EventItem from "./elements/EventItem";
import * as Styled from "./styled";

type IProps = Moim.Blockit.V2.ICalendarBlock;

const CalendarComponent = ({ calendarConfig }: IProps) => {
  const { currentUser } = useCurrentUser();
  const userLocale = currentUser?.locale ?? window.navigator.language;

  const [initFetchedId, setInitFetchedId] = React.useState<number | null>(null);
  const { calendarMode, selectedDateValue } =
    CalendarBlock.Contexts.Calender.useCalendarContext();
  const { fetchEvents } =
    CalendarBlock.Contexts.Event.useCalendarEventContext();
  const monthCalendarConfig = calendarConfig.calendar;
  const dayAndWeekConfig = calendarConfig.weekAndDay;
  const templateId =
    calendarMode === "month"
      ? monthCalendarConfig?.templateId
      : dayAndWeekConfig?.templateId;

  /**
   * @description CDM only once.
   * selectedDateValue를 기준 앞뒤 15일간의 이벤트를 가져온다. 총 30일
   */
  React.useEffect(() => {
    if (initFetchedId) return;

    fetchEvents(selectedDateValue, 15, {
      templateId,
    }).then(() => {
      setInitFetchedId(selectedDateValue);
    });
  }, []);

  /**
   * @description selectedDateValue가 변경되면 이벤트를 추가로 가져온다.
   */
  React.useEffect(() => {
    if (initFetchedId !== null && initFetchedId !== selectedDateValue) {
      fetchEvents(selectedDateValue, 4, {
        templateId,
      });

      const intervalId = setInterval(() => {
        fetchEvents(selectedDateValue, 4, {
          templateId,
        });
      }, 10000); // 10 seconds

      return () => clearInterval(intervalId);
    }
  }, [initFetchedId, selectedDateValue]);

  return (
    <Styled.Container>
      <Styled.HeadContainer>
        <CalendarBlock.Header userLocale={userLocale} />
        <CalendarBlock.DayAndWeekIndicator
          DateItemCreator={props => (
            <DateItem {...props} userLocale={userLocale} />
          )}
        />
      </Styled.HeadContainer>

      <CalendarBlock.BodyContainer
        hasTemplate={Boolean(templateId)}
        EmptyEventElement={undefined}
        LoadingElement={undefined}
        EventItemContainerCreator={props => <EventItem {...props} />}
      />
    </Styled.Container>
  );
};

export default CalendarComponent;
